const { editmode } = window.mds || {};
if (!!editmode === true) {
  const includeEditmodeFile = () => import(/* webpackChunkName: 'editmode' */ '@/scss/editmode.scss');
  includeEditmodeFile();
}
